// import React from "react";
// import CurrentProcessLogs from "../../Common/CurrentProcessLogs";

// export default function PostProcessingProcessLogs({ logs, processedfiles, unprocessedfiles }) {
//     return (
//         <CurrentProcessLogs
//             logs={logs}
//             processedfiles={processedfiles}
//             unprocessedfiles={unprocessedfiles}
//         />
//     );
// }

import React, { useState } from "react";

function StatusBadge({ status }) {
    const s = (status || "").toLowerCase();
    const styles = {
        success:    { background: "#e6f4ea", color: "#34a853" },
        submitted:  { background: "#fff3e0", color: "#f9a825" },
        processing: { background: "#e8f0fe", color: "#1a73e8" },
        inprogress: { background: "#e8f0fe", color: "#1a73e8" },
        error:      { background: "#fce8e6", color: "#ea4335" },
        failed:     { background: "#fce8e6", color: "#ea4335" },
    };
    const style = styles[s] || { background: "#f1f3f4", color: "#666" };
    return (
        <span style={{
            ...style,
            padding: "2px 10px",
            borderRadius: "12px",
            fontSize: "12px",
            fontWeight: 500,
        }}>
            {status || "-"}
        </span>
    );
}

function FileTable({ files }) {
    if (!files || files.length === 0) {
        return (
            <div style={{ padding: "14px 16px", color: "#888", fontSize: "14px" }}>
                No Files Present
            </div>
        );
    }
    return (
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
            <thead>
                <tr style={{ background: "#f5f5f5" }}>
                    {["#", "File Name", "Status", "Start Date"].map(h => (
                        <th key={h} style={{
                            padding: "8px 12px", textAlign: "left",
                            fontWeight: 600, color: "#444",
                            borderBottom: "1px solid #e0e0e0"
                        }}>{h}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {files.map((file, i) => {
                    const name = file.filename || file.name || file.file_name || "Unknown";
                    return (
                        <tr key={file.file_code || i} style={{ borderBottom: "1px solid #f0f0f0" }}>
                            <td style={{ padding: "8px 12px", color: "#666" }}>{i + 1}</td>
                            <td style={{ padding: "8px 12px", color: "#333" }}>{name}</td>
                            <td style={{ padding: "8px 12px" }}>
                                <StatusBadge status={file.status} />
                            </td>
                            <td style={{ padding: "8px 12px", color: "#666" }}>
                                {file.start_date_time || "-"}
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
}

function TabButton({ label, count, active, onClick }) {
    return (
        <button onClick={onClick} style={{
            padding: "8px 20px",
            border: "none",
            background: "none",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: active ? 600 : 400,
            color: active ? "#5b5fc7" : "#555",
            borderBottom: active ? "2px solid #5b5fc7" : "2px solid transparent",
            display: "flex", alignItems: "center", gap: "6px",
        }}>
            {label}
            <span style={{
                background: "#fce8e8", color: "#d44",
                borderRadius: "50%", width: "20px", height: "20px",
                display: "inline-flex", alignItems: "center",
                justifyContent: "center", fontSize: "11px", fontWeight: 600,
            }}>
                {count}
            </span>
        </button>
    );
}

export default function PostProcessingProcessLogs({ logs, processedfiles, unprocessedfiles }) {
    const [activeTab, setActiveTab] = useState("processed");

    // Build status lookup from logs (updated to "success"/"error") 
    // since processedfiles retains original "submitted" status
    const logsByFilename = {};
    (logs || []).forEach(l => { if (l.filename) logsByFilename[l.filename] = l; });

    const enrich = (list) => (list || []).map(f => {
        const fname = f.filename || f.name || f.file_name || "";
        return { ...f, status: logsByFilename[fname]?.status || f.status };
    });

    const enrichedProcessed = enrich(processedfiles);
    const enrichedUnprocessed = enrich(unprocessedfiles);

    // ---- Logs table ----
    const hasLogs = logs && logs.length > 0;

    return (
        <div>
            {/* ── Logs Table ── */}
            {!hasLogs ? (
                <div style={{ padding: "14px 16px", color: "#888", fontSize: "14px" }}>
                    Please Start Process to get logs
                </div>
            ) : (
                <>
                    <div style={{ padding: "8px 12px" }}>
                        <button style={{
                            padding: "6px 16px", border: "1px solid #c5cae9",
                            borderRadius: "4px", background: "#e8eaf6",
                            color: "#3949ab", cursor: "pointer", fontSize: "13px"
                        }}
                            onClick={() => {
                                const rows = logs.map((l, i) =>
                                    [i + 1, l.filename, l.status, l.status_code,
                                     l.status_message, l.creation_date
                                    ].join(",")
                                ).join("\n");
                                const blob = new Blob(
                                    ["#,File Name,Status,Status Code,Status Message,Date\n" + rows],
                                    { type: "text/csv" }
                                );
                                const a = document.createElement("a");
                                a.href = URL.createObjectURL(blob);
                                a.download = "post_processing_logs.csv";
                                a.click();
                            }}>
                            Download Logs
                        </button>
                    </div>

                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
                        <thead>
                            <tr style={{ background: "#f5f5f5" }}>
                                {["#", "File Name", "Status", "Status Code", "Status Message", "API Version", "Start Date", "Execution Date"].map(h => (
                                    <th key={h} style={{
                                        padding: "8px 12px", textAlign: "left",
                                        fontWeight: 600, color: "#444",
                                        borderBottom: "1px solid #e0e0e0"
                                    }}>{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {logs.map((l, i) => (
                                <tr key={i} style={{ borderBottom: "1px solid #f0f0f0" }}>
                                    <td style={{ padding: "8px 12px", color: "#666" }}>{i + 1}</td>
                                    <td style={{ padding: "8px 12px", color: "#333" }}>{l.filename}</td>
                                    <td style={{ padding: "8px 12px" }}><StatusBadge status={l.status} /></td>
                                    <td style={{ padding: "8px 12px", color: "#666" }}>{l.status_code ?? "-"}</td>
                                    <td style={{ padding: "8px 12px", color: "#555", maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                                        title={l.status_message}>{l.status_message || "-"}</td>
                                    <td style={{ padding: "8px 12px", color: "#666" }}>{l.api_version || "-"}</td>
                                    <td style={{ padding: "8px 12px", color: "#666" }}>{l.start_date || "-"}</td>
                                    <td style={{ padding: "8px 12px", color: "#666" }}>
                                        {l.creation_date ? new Date(l.creation_date).toLocaleString("en-GB", {
                                            day: "2-digit", month: "2-digit", year: "numeric",
                                            hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false
                                        }).replace(",", "") : "-"}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )}

            {/* ── Processed / Unprocessed file tabs ── */}
            <div style={{ marginTop: "12px", borderTop: "1px solid #e0e0e0" }}>
                <div style={{ display: "flex", borderBottom: "1px solid #e0e0e0" }}>
                    <TabButton
                        label="Processed Files"
                        count={enrichedProcessed.length}
                        active={activeTab === "processed"}
                        onClick={() => setActiveTab("processed")}
                    />
                    <TabButton
                        label="Unprocessed Files"
                        count={enrichedUnprocessed.length}
                        active={activeTab === "unprocessed"}
                        onClick={() => setActiveTab("unprocessed")}
                    />
                </div>
                <FileTable files={activeTab === "processed" ? enrichedProcessed : enrichedUnprocessed} />
            </div>
        </div>
    );
}

